/**
 * Configuración de la capa base del mapa.
 *
 * Vive acá y no dentro de GenericMap porque también la necesita el caché de
 * tiles (utils/mapTileCache.js) para saber a qué host tiene que interceptar.
 *
 * Capa por defecto: OpenStreetMap estándar. No requiere api_key (a diferencia
 * de CARTO, que estampa "API KEY REQUIRED" sobre los tiles anónimos) y es el
 * estilo del que deriva CARTO Voyager, así que la jerarquía vial y la
 * rotulación se ven prácticamente iguales.
 */
export const MAP_TILE_URL =
  import.meta.env.VITE_MAP_TILE_URL || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png';

export const MAP_TILE_ATTRIBUTION =
  import.meta.env.VITE_MAP_TILE_ATTRIBUTION ||
  '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

/**
 * Último zoom con tiles reales del proveedor. Más allá, Leaflet escala el último
 * nivel disponible en vez de pedir tiles inexistentes (que se verían en blanco).
 */
export const MAP_TILE_MAX_NATIVE_ZOOM =
  Number(import.meta.env.VITE_MAP_TILE_MAX_NATIVE_ZOOM) || 19;

/**
 * Hosts que sirven los tiles, derivados de la URL configurada.
 * Si la plantilla usa `{s}`, se expande con los subdominios por defecto de
 * Leaflet (a, b, c). Devuelve [] si la URL no se puede interpretar.
 */
export const getMapTileHosts = (urlTemplate = MAP_TILE_URL) => {
  const match = /^https?:\/\/([^/]+)/i.exec(urlTemplate);
  if (!match) return [];

  const host = match[1];
  if (!host.includes('{s}')) return [host];
  return ['a', 'b', 'c'].map((subdomain) => host.replace('{s}', subdomain));
};
